import { createStoreSelector } from "../selectors";
export const selectMissions = (state) => createStoreSelector(state, 'missions')(state);
//# sourceMappingURL=missions.selectors.js.map